import { Link } from 'react-router-dom';

import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import { useGlobal } from '~/hooks/useGlobal';

import { createCategoryUrl } from '../shared/utils';

import styles from './BannerPromoBlock.module.scss';
import { BannerPromoBlockProps } from './interfaces';

const BannerPromoBlock = ({ category }: BannerPromoBlockProps) => {
  const { isMobile } = useGlobal();

  if (!category || !category.subcategory[0]?.id) {
    return null;
  }

  const { name, previewImage, previewImageThumb, subcategory } = category;
  const categoryId = subcategory[0]?.id;

  const img = (
    <CloudflareResponseImage
      src={isMobile ? previewImageThumb || previewImage : previewImage}
      alt={name}
      loading="lazy"
      className={styles.img}
      srcSetParams={defaultSrcSetParams}
    />
  );

  if (!categoryId) {
    return <div className={styles.promo}>{img}</div>;
  }

  return (
    <Link
      to={createCategoryUrl({ id: categoryId })}
      className={styles.container}
    >
      {img}
    </Link>
  );
};

export default BannerPromoBlock;
